module.exports = __webpack_public_path__ + "img/2024-11-15a_2.18c1af2e.jpg";